import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Popconfirm} from 'antd';
import {Spinner} from 'components/ui/Spinner';

interface FromShellProps {
  isDirty?: boolean;
  onSubmitLabel?: string;
  onReset?: () => void;
  onSubmit?: () => void;
  onSubmitAndExit?: () => void;
  onDelete?: () => void;
  isLoading?: boolean;
  children?: React.ReactNode;
}

export const FormShell: React.FC<FromShellProps> = ({
  isDirty,
  onReset,
  onSubmit,
  onSubmitAndExit,
  onDelete,
  onSubmitLabel,
  isLoading = false,
  children,
}) => {
  const {t} = useTranslation();

  return (
    <div className="flex flex-col flex-col-reverse md:flex-col lg:flex-col">
      {(onReset || onSubmitAndExit || onSubmit) && (
        <div className="flex flex-row-reverse mb-6 mt-4 md:mt-0 lg:mt-0">
          <div className="w-full md:basis-1/2 flex gap-2 justify-end">
            {onReset && (
              <Button className="w-40" size="large" onClick={onReset} disabled={!isDirty}>
                {t('Discard changes')}
              </Button>
            )}
            {onDelete && (
              <Popconfirm
                key="delete"
                placement="bottomRight"
                title={t('Are you sure you want to remove?')}
                onConfirm={onDelete}
                okText={t('Yes')}
                cancelText={t('No')}
              >
                <Button className="w-40" size="large">
                  {t('Remove')}
                </Button>
              </Popconfirm>
            )}
            {onSubmitAndExit && (
              <Button className="w-40" size="large" type="dashed" onClick={onSubmitAndExit}>
                {t('Save and exit')}
              </Button>
            )}
            {onSubmit && (
              <Button className="w-40" size="large" type="primary" onClick={onSubmit}>
                {onSubmitLabel ?? t('Save')}
              </Button>
            )}
          </div>
        </div>
      )}
      {children}
      {isLoading && (
        <div className="absolute top-0 left-0 w-full h-full bg-white opacity-50 z-10 h-screen flex justify-center items-center skip-fade">
          <Spinner />
        </div>
      )}
    </div>
  );
};
